var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPepLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 612",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:9.9515;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524.5,396.3c-7.5,1.9-15.3,2.9-23.3,2.9c-35.2,0-65.9-19.6-81.7-48.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M585.1,265.9c5.9,12.2,9.1,25.8,9.1,40.3c0,19.2-5.8,37-15.7,51.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415.1,270.4c14-33.7,47.2-57.4,86-57.4c17.9,0,34.7,5.1,48.9,13.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.4,363.8c-9.7-6.2-17.7-14.8-23.3-25"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M566.7,326.1c-8.5,28.1-34.6,48.5-65.5,48.5c-6.6,0-13-0.9-19-2.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.2,237.8c1,0,2-0.1,3-0.1c35,0,63.8,26.2,67.9,60.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.7,280.9c7.1-17.9,21.6-32.1,39.7-38.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.8,344.7c-6.1,3.3-13.2,5.2-20.7,5.2c-12.2,0-23.3-5.1-31.2-13.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M534.1,278.4c6.5,7.6,10.4,17.4,10.4,28.2c0,12.7-5.4,24.1-14.1,32"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.6,275.7c7.8-7.8,18.6-12.5,30.5-12.5c9.7,0,18.7,3.2,25.9,8.6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.8,270.8H212c10.3,0,14.1,1.6,17.1,4c4.3,3.6,6.5,9.1,6.5,14.7c0,5.6-2.3,11.5-5.9,14.5 c-3.8,3.2-7.6,4.8-16.2,4.8h-6.1v17.4h-13.6V270.8z M207.4,296.5h5.8c2.7,0,8.8,0,8.8-6.7c0-6.5-6.3-6.5-9.4-6.5h-5.2V296.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240.5,270.8h30.8v12.4h-17.2v8.6h16.7v12.4h-16.7v9.5h17.2v12.4h-30.8V270.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M279.2,270.8h18.1c10.3,0,14.1,1.6,17.1,4c4.3,3.6,6.5,9.1,6.5,14.7c0,5.6-2.3,11.5-5.8,14.5 c-3.8,3.2-7.6,4.8-16.2,4.8h-6.1v17.4h-13.6V270.8z M292.7,296.5h5.8c2.7,0,8.8,0,8.8-6.7c0-6.5-6.3-6.5-9.4-6.5h-5.2V296.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.5,315.3c0,6.4,4.4,10,10.1,10c5.9,0,9.7-4.5,9.5-9.7c-0.1-5.5-3.1-8.1-9.6-9.5c-6-1.7-10.5-3.4-10.7-10.3 c0-6.6,4.9-10.3,10.8-10.3c5.8,0.1,10.5,3.5,10.5,10.3H347c0-6-4.1-8.5-8.4-8.4c-5.3,0-8.9,3.6-8.7,8.3c0.2,4.8,3.1,6.6,8.7,8.2 c5.2,1.4,11.2,2.8,11.6,11.3c0.4,6.5-4.8,11.9-11.6,11.9c-6.6,0-12.7-4.7-12.2-12H328.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M359.3,306.7c0.1,13,11,18.7,18.8,18.7c7.3,0,13.8-3.8,16.9-10.5h2.3c-3.7,8.5-11.3,12.5-19.3,12.5 c-12.1,0-20.9-9-20.9-20.8v0.1c0-11.9,9.1-20.9,21-20.9c10.6,0,20.3,7.6,20.8,19.9l-0.1,1.1H359.3z M396.8,304.7 c-0.5-9.6-9.4-17.5-18.7-17.2c-9.8,0-18.1,7.1-18.7,17.2H396.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.8,294.2h0.2c2.5-5.8,9.7-8.8,16-8.6c5.1,0,9.3,1.3,12.4,4c3.9,3.3,5.8,8.6,5.8,15.7v21H440v-21 c0-6.9-1.9-11.3-4.9-14c-3.1-2.8-7.2-3.8-11.2-3.8c-10,0.1-16.1,5.9-16.1,15.9v22.9h-2.1v-39.7h2.1V294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M452.3,315.3c0,6.4,4.3,10,10.1,10c5.9,0,9.7-4.5,9.5-9.7c-0.1-5.5-3.1-8.1-9.6-9.5c-6-1.7-10.5-3.4-10.7-10.3 c0-6.6,4.9-10.3,10.8-10.3c5.8,0.1,10.5,3.5,10.5,10.3h-2.1c0-6-4.1-8.5-8.4-8.4c-5.3,0-8.9,3.6-8.7,8.3c0.2,4.8,3.1,6.6,8.7,8.2 c5.2,1.4,11.2,2.8,11.6,11.3c0.4,6.5-4.8,11.9-11.6,11.9c-6.6,0-12.7-4.7-12.2-12H452.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M481.7,306.7c0.1,13,11,18.7,18.8,18.7c7.3,0,13.8-3.8,16.9-10.5h2.3c-3.7,8.5-11.3,12.5-19.3,12.5 c-12.1,0-20.9-9-20.9-20.8v0.1c0-11.9,9.1-20.9,21-20.9c10.6,0,20.3,7.6,20.8,19.9l-0.1,1.1H481.7z M519.2,304.7 c-0.5-9.6-9.4-17.5-18.7-17.2c-9.8,0-18.1,7.1-18.7,17.2H519.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepLogo);
export default __webpack_public_path__ + "static/media/pep-logo.ddfff4b96f84d133d4d6ae85c984e63c.svg";
export { ForwardRef as ReactComponent };